/* eslint-disable no-shadow */
export type DgEntertainmentProps = {
  type: string;
};

export enum EntertainmentTypes {
  PRESENTATION = 'presentation',
  EFIRMA = 'efirma',
  PROFILE = 'profile',
  REFERRAL = 'referral',
  SAT_ERROR = 'satError',
  RESULT_ESTIMATED = 'resultEstimated',
}
